var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.00299072,
    y: 0.135132,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#50AF95"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2446 13.1351H13.704V16.1627H18.4605V20.6126H21.4881V16.1627H26.2446V13.1351Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0031 21.0866C16.0683 21.0866 12.8783 20.4639 12.8783 19.6956C12.8783 18.9275 16.0682 18.3046 20.0031 18.3046C23.9378 18.3046 27.1277 18.9275 27.1277 19.6956C27.1277 20.4639 23.9378 21.0866 20.0031 21.0866ZM28.003 19.9275C28.003 18.9369 24.4213 18.1339 20.0031 18.1339C15.5849 18.1339 12.003 18.9369 12.003 19.9275C12.003 20.7999 14.7804 21.5267 18.4607 21.6877V28.0758H21.488V21.6903C25.1966 21.5342 28.003 20.8044 28.003 19.9275Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.dcdedf8ad3c93647d8c4e2edb58eed07.svg";
export { ForwardRef as ReactComponent };